export default "__VITE_ASSET__DPi$mMax__"